

























































































































import firebase from 'firebase/app'
import {mapState} from 'vuex'
import Footer from '../common/Footer'

export default {
  name: 'Artists',
  components: {
    Footer,
  },
  props: {

  },
  computed: {
    ...mapState({
      uid: (state) => state.admin.uid,
      name: (state) => state.admin ? state.admin.userInfo.name : 'Loading...',
      parentToken: (state) => state.parent.parentToken,
    }),
    siteTitle: function () {
      if (this.name !== undefined && this.name != null) {
        return this.name+"'s Dashboard"
      } else {
        return "Loading..."
      }
    }
  },
  watch: {
    uid() {
      // console.log("UID in Artists is now: " + this.uid)
      if (this.uid != null) {
        this.$store.dispatch('admin/loadCurrentArtist')
      } else {
        // The UID changed from undefined to null, this means that they really
        // are not logged in.

        // Go to the login page
        this.$router.push({name: "Login"})
      }

    }
  },
  data() {
    return {
      categories: null,
      dashboard: 'I',
      toggleMenu: false,
      settingsItems: [
        {title: 'Account', icon: this.$vuetify.icons.account, to: '/artists/account/'},
        {title: 'Site', icon: this.$vuetify.icons.siteSettings , to: '/artists/sitesettings/'},
        {title: 'Seller', icon: this.$vuetify.icons.sellerSettings, to: '/artists/seller/'},
      ],
    }
  },
  mounted() {

    // Load theme from a cookie if present
    this.$store.dispatch('themeInfo/loadSellerThemeCookie')

    if (this.uid != null) {
      // Now load the artist's info
      this.$store.dispatch('admin/loadCurrentArtist')
    }
  },
  methods: {
    gotoDashboard() {
      this.$router.push({name: 'Dashboard'})
    },
    async backToParentPortal() {
      if (!this.parentToken) {
        console.error('Error: Cannot go back to parent portal, no parent token.')
      } else {
        // Stop watching the Artist
        await this.$store.dispatch("admin/stopWatchingCurrentArtist")
        // Login as the parent and return to the parent portal
        // Now login with the token
        this.$router.push({name: 'ReturnToParentPortal'})
      }
    },
    logout() {
      console.log("DEBUG: signout in Artists")
      firebase.auth().signOut().then(() => {
        this.$router.replace('/login')
      })
    },
    gotoItems() {
      console.log('GOTO ITEMS')
      this.$router.push({path: '/artists/items/'})
    },
    gotoProfile() {
      this.$router.push({path: '/artists/profile/'})
    },
    gotoOrders() {
      this.$router.push({path: '/artists/orders/'})
    },
    addEditItem(data) {
      // console.log('ADD ITEM DATA WAS: ' + JSON.stringify(data))
      this.$router.push({name: 'addedititem', params: data})
    },
    viewOrder(data) {
      console.log(data)
      this.$router.push({path: '/artists/vieworder/' + data.orderData.id})
    },
  },
}
